/* eslint-disable */
import { useState, useContext, useEffect } from 'react'
import styles from './index.module.scss'
import Breadcrumb from '../../components/core/breadcrumb'
import { PageContext } from '../../context/PageContextProvider'
import translate from '../../utils/translate.json'
import img from '../../assets/images/book.png'
import { EmptyStar, FullStar, Book } from '../../icons'
import { Button } from '../../components/core/button'
import { Swiper, SwiperSlide } from 'swiper/react'
import Subscribe from '../../components/pages/subscribe'
import { MagazineCard } from '../../components/core/cards'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'
import 'swiper/css'
import '../Library/styles.css'

const BookDetails = ({ className }) => {
  const title = {
    AZ: 'Cities in the Global Economy',
    ENG: 'Cities in the Global Economy',
    RU: 'Cities in the Global Economy',
  }
  const { language } = useContext(PageContext)
  const crumbs = [
    {
      link: '/',
      text: translate.home,
    },
    {
      link: '#',
      text: translate.useful,
    },
    {
      link: '#',
      text: title,
    },
  ]
  const [load, setLoad] = useState(false)
  const [info, setInfo] = useState([])
  useEffect(() => {
    (async () => {

    const data1 = await PagesAPI.getMagazinePageInfo()
    await setInfo(data1.data)
    await setLoad(true)
  
    })();
  }, [])
  const data2 = [
    {
      id: 1,
      image: img,
      title: 'Investment Strategy',
      label: 'Top seller',
    },
    {
      id: 2,
      image: img,
      label: 'Top seller',
      title: 'Investment Strategy',
      label: 'Top seller',
    },
    {
      id: 3,
      image: img,
      title: 'Investment Strategy',
      label: 'Top seller',
    },
    {
      id: 4,
      image: img,
      title: 'Investment Strategy',
      label: 'Top seller',
    },
  ]
  return load ? (
    <section className={`${styles.container} ${className}`}>
      <Breadcrumb crumbs={crumbs} />
      <div className={styles.content}>
        <div>
          <h1>{title[language]}</h1>
          <p>
            For almost all of human history, people have lived in small towns,
            villages or the countryside. For almost all of human history, people
            have lived in small towns, villages or the countryside.For almost
            all of human history, people have lived in small towns, villages or
            the countryside.For almost all of human history, people have lived
            in small towns, villages or the countryside.For almost all of human
            history, people have lived in small towns, villages or the
            countryside.
          </p>
          <div>
            <span>{translate.downloads[language]}</span>
            <p>13.155</p>
          </div>
          <div>
            <span>{translate.edition[language]}</span>
            <p>2016</p>
          </div>
          <div>
            <span>{translate.rating[language]}</span>
            <div>
              <FullStar />
              <FullStar />
              <FullStar />
              <EmptyStar />
              <EmptyStar />
            </div>
          </div>
          <Button to={'#'}>{translate.download[language]}</Button>
        </div>
        <img src={img} alt={title} />
      </div>
      <h2>
        <Book />
        {translate.recommended[language]}
      </h2>
      <Swiper slidesPerView={'auto'} spaceBetween={32} className="book-swiper">
        {data2.map((item) => (
          <SwiperSlide key={item.id}>
            <MagazineCard
              img={item.image}
              title={item.title}
              label={item.label}
              to={`/book/${item.id}`}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  ) : (
    <Loading />
  )
}

export default BookDetails
